import React from 'react'
import "./toolsection.css"
import undraw from "../../assets/images/undraw.png"
import Typewriter from 'typewriter-effect';
const ToolsSection = ({ data }) => {
  return (
    <section className="">
        <div className="tools-section">
                    <div className="tools-grid-container">
                        <div className="tools-left">
                            <header className="tools-header">
                                <h1>Hey! here are the tools I used in the</h1>
                                <h1>Development of this Web </h1>
                                <h1>Application.</h1>
                            </header>
                            <div className="tools-body">
                                <span className="span1">Tools are </span>
                                <span>
                                    <Typewriter
                                        options={{
                                            strings: data.tools,
                                            autoStart: true,
                                            loop: true,
                                        }}
                                    />
                                </span>
                            </div>
                            <a href={data.url} target="_blank" rel="noreferrer noopener" style={{textDecoration: "none"}}>                                       
                                <div className="visit-site-btn">
                                    <span>OPEN SITE</span>
                                </div>
                            </a>
                        </div>
                        <div className="tools-image">
                            <img src={undraw} alt="" />
                        </div>
                    </div>
                </div>
    </section>
  )
}

export default ToolsSection